import box from "./styles/box";
import creative from "./styles/creative";
import docbox from "./styles/docbox";
import light from "./styles/light";
import topicsbox from "./styles/topicsbox";
import boxed_tabbed_docs from "./styles/boxed-tabbed-docs";
import flat_tabbed_docs from "./styles/flat-tabbed-docs";
import tabbed_doc_list from "./styles/tabbed-doc-list";
import collaborative_docs from "./styles/collaborative-docs";

const MultiPreset = ({ attributes, docSections, multiDocs, articlesNumber }) => {
    const { docPreset, parentTitle } = attributes;

    // Mapping presets to components
    const presetComponents = {
        box: box,
        creative: creative,
        docbox: docbox,
        light: light,
        topicsbox: topicsbox,
        boxed_tabbed_docs: boxed_tabbed_docs,
        flat_tabbed_docs: flat_tabbed_docs,
        tabbed_doc_list: tabbed_doc_list,
        collaborative_docs: collaborative_docs
    };

    // Fallback to light if docPreset is not found in the mapping
    const Preset = presetComponents[docPreset] || light;
    
    return (
        <Preset
            attributes={attributes}
            docSections={docSections}
            multiDocs={multiDocs}
            articlesNumber={articlesNumber}
        />
    );
};

export default MultiPreset;
